import React from 'react';
export const PaymentBadges: React.FC<{
  className?: string;
}> = ({
  className = ''
}) => {
  return <div className={`flex flex-wrap items-center justify-center gap-2 ${className}`} data-id="element-205">
      <div className="px-3 py-1 bg-[#1434CB] text-white text-xs font-bold rounded italic" data-id="element-206">
        VISA
      </div>
      <div className="px-3 py-1 bg-gradient-to-r from-[#EB001B] to-[#F79E1B] text-white text-xs font-bold rounded" data-id="element-207">
        mastercard
      </div>
      <div className="px-3 py-1 bg-[#003087] text-white text-xs font-bold rounded italic" data-id="element-208">
        PayPal
      </div>
      <div className="px-3 py-1 bg-[#2E77BC] text-white text-xs font-bold rounded" data-id="element-209">
        AMEX
      </div>
      <div className="px-3 py-1 bg-black text-white text-xs font-bold rounded flex items-center gap-1" data-id="element-210">
        <span data-id="element-211"></span> Pay
      </div>
    </div>;
};